/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Placeholder, PlaceholderText } from 'sarsaparilla';
import FacilitySummaryIconsPlaceholder from './FacilitySummaryIconsPlaceholder';

/** Facility Snapshot section skeleton (heading, overview lines, icons grid, details CTA). */
export default function FacilitySnapshotPlaceholder() {
    return (
        <div
            className="campground-page-v3-facility-snapshot campground-page-v3-section"
            aria-hidden="true"
        >
            <Placeholder
                className="campground-page-v3-heading"
                height="32px"
                width="220px"
            />
            <div className="campground-page-v3-facility-description-text">
                <PlaceholderText fontSize={21} lineHeight={22} lines={3} />
            </div>
            <FacilitySummaryIconsPlaceholder />
            <Placeholder height="44px" width="100%" />
        </div>
    );
}
